export default __webpack_public_path__ + "images/c7038690107d2064ea4398bd762f76e4-chargeAfter-v1.svg";